import React from 'react';
import './BtnLoader.css';

const BtnLoader = () => {
  return (
    <React.Fragment>
        <div className="spinner"></div>
    </React.Fragment>
  )
}

export default BtnLoader